import { render, staticRenderFns } from "./areastaff.vue?vue&type=template&id=e0c3a20a&scoped=true&"
import script from "./areastaff.vue?vue&type=script&lang=js&"
export * from "./areastaff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0c3a20a",
  null
  
)

export default component.exports